// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetHydrantMapItemsListRequestModel from '../../model/get-hydrant-map-items-list-request-model';
import GetHydrantMapItemsListRequestDTO from '../dto/get-hydrant-map-items-list-request-dto';
import dtoSchema from '../schemas/get-hydrant-map-items-list-request-schema';

export default abstract class GetHydrantMapItemsListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetHydrantMapItemsListRequestDTO>) {
    super();
    if (data) {
      this.fireDepartmentId = data.fireDepartmentId;
    }
  }
  /**
  * @type {int64}
  */
  fireDepartmentId?: number;

  static toModel(dto: DeepPartial<GetHydrantMapItemsListRequestDTO>): GetHydrantMapItemsListRequestModel;
  static toModel(dto: DeepPartial<GetHydrantMapItemsListRequestDTO> | undefined | null): GetHydrantMapItemsListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetHydrantMapItemsListRequestDTO> | undefined | null): GetHydrantMapItemsListRequestModel | undefined {
    return dto ? new GetHydrantMapItemsListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetHydrantMapItemsListRequestModel> | GetHydrantMapItemsListRequestModel): GetHydrantMapItemsListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      fireDepartmentId: unwrapped.fireDepartmentId,
    } as GetHydrantMapItemsListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetHydrantMapItemsListRequestModel, can not map to GetHydrantMapItemsListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
